import React from 'react';
import PropTypes from 'prop-types';
import ResultsHeading from './ResultsHeading';

const ResultsList = ({
	children,
	ariaLabelledById,
	label,
	labelSize,
	showMoreText,
	showMoreHandler
}) => {
	const optionalAttributes = {
		...(label && { 'aria-labelledby': ariaLabelledById })
	};

	return (
		<div className="site-text-search-results">
			{label && (
				<ResultsHeading
					label={label}
					labelSize={labelSize}
					ariaLabelledById={ariaLabelledById}
				/>
			)}
			<nav {...optionalAttributes}>
				<ul className="list-group mb-0">{children}</ul>
			</nav>
			{showMoreText ? (
				<button
					className="text-link ddc-font-size-xsmall w-100 text-left px-4 py-3"
					onClick={showMoreHandler}
				>
					{showMoreText}
				</button>
			) : (
				''
			)}
		</div>
	);
};
ResultsList.propTypes = {
	children: PropTypes.arrayOf(PropTypes.element).isRequired,
	labelSize: PropTypes.number,
	label: PropTypes.string,
	ariaLabelledById: PropTypes.string,
	showMoreText: PropTypes.string,
	showMoreHandler: PropTypes.func
};
ResultsList.defaultProps = {
	label: '',
	labelSize: 5,
	ariaLabelledById: 'results-list-0',
	showMoreText: '',
	showMoreHandler: () => {}
};
export default ResultsList;
